import { CallAPI } from "../utils/api";

export async function AddNote(note, date) {
  const data = {
    note: note,
    date: date,
  };
  return CallAPI(
    `/addNote`,
    {
      method: "POST",
      body: JSON.stringify(data),
    },
    true
  );
}

export async function GetNotes(date) {
  return CallAPI(
    `/getNotes/${date}`,
    {
      method: "GET",
    },
    true
  );
}

export async function DeleteNote(id) {
  return CallAPI(
    `/deleteNote/${id}`,
    {
      method: "DELETE",
    },
    true
  );
}


export async function EditNote(id, note) {
  const data = {
    note: note,
  };  
  return CallAPI(
    `/editNote/${id}`,
    {
      method: "PATCH",
      body: JSON.stringify(data),
    },
    true
  );
}


